import { Box, Container, Grid, Typography, Link, Stack, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useTheme } from '../contexts/ThemeContext';

const footerLinks = [
    {
        heading: 'Company',
        links: [
            { label: 'About Us', href: '/about' },
            // { label: 'Services', href: '#' },
            { label: 'Join our Team', href: '/careers' },
        ],
    },
    {
        heading: 'For Customers',
        links: [
            { label: 'Open Account', href: '/register' },
            { label: 'Track Parcel', href: '/tracking' },
            { label: 'Partner Login', href: '/login' },
            //   { label: 'FAQs', href: '#' },
            { label: 'Terms & Conditions', href: '/terms-and-conditions' },
        ],
    }
];

const Footer = () => {
    const { mode } = useTheme();
    const getLogoSrc = () => {
        if (mode === 'light') {
            return '/logo.svg';
        }
        return '/logo-dark.svg'; // Dark theme always uses dark logo
    };
    
    // Dynamic background color based on theme
    const getBackgroundColor = () => {
        return mode === 'dark' ? '#191c1d' : '#f8f9fa';
    };

    // Dynamic text color based on theme
    const getTextColor = () => {
        return mode === 'dark' ? 'grey.100' : 'grey.700';
    };

    // Dynamic secondary text color based on theme
    const getSecondaryTextColor = () => {
        return mode === 'dark' ? 'grey.300' : 'grey.600';
    };

    // Dynamic border color based on theme
    const getBorderColor = () => {
        return mode === 'dark' ? '#232627' : '#e0e0e0';
    };

    return (
        <Box sx={{ 
            borderTop: `1px solid ${getBorderColor()}`,
            bgcolor: getBackgroundColor(), 
            color: getTextColor(), 
            pt: 8, 
            pb: 2, 
            mt: 8 
        }}>
            <Container maxWidth="xl">
                <Grid container spacing={4} justifyContent="center">
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Box component="img" src={getLogoSrc()} alt="Logo" sx={{ height: 40, mr: 2 }} />
                        </Box>
                        <Typography sx={{ color: getSecondaryTextColor(), maxWidth: 340 }}>
                            We believe in Continuous Professional Development towards a leading role.
                        </Typography>
                        <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
                            <IconButton href="#" sx={{ color: getSecondaryTextColor(), '&:hover': { color: 'secondary.main' } }}>
                                <FacebookIcon fontSize="medium" />
                            </IconButton>
                            <IconButton href="#" sx={{ color: getSecondaryTextColor(), '&:hover': { color: 'secondary.main' } }}>
                                <LinkedInIcon fontSize="medium" />
                            </IconButton>
                            <IconButton href="#" sx={{ color: getSecondaryTextColor(), '&:hover': { color: 'secondary.main' } }}>
                                <InstagramIcon fontSize="medium" />
                            </IconButton>
                        </Stack>
                    </Grid>
                    {footerLinks.map((col) => (
                        <Grid size={{ xs: 12, sm: 4, md: 3 }} key={col.heading}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'secondary.main', mb: 2 }}>
                                {col.heading}
                            </Typography>
                            <Stack spacing={1}>
                                {col.links.map((link) => (
                                    <Link
                                        key={link.label}
                                        component={RouterLink}
                                        to={link.href}
                                        underline="none"
                                        sx={{ 
                                            color: mode === 'dark' ? 'grey.200' : 'grey.700', 
                                            '&:hover': { color: 'secondary.main' }, 
                                            fontSize: 16 
                                        }}
                                    >
                                        {link.label}
                                    </Link>
                                ))}
                            </Stack>
                        </Grid>
                    ))}
                </Grid>
                <Box sx={{ borderTop: `1px solid ${getBorderColor()}`, mt: 6, pt: 3, textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ color: mode === 'dark' ? 'grey.400' : 'grey.500' }}>
                        Copyrights © {new Date().getFullYear()} All Rights Reserved.
                        <br />
                        Designed and Developed by <Link href="https://hesannaveed.com" target="_blank" rel="noopener noreferrer" sx={{ color: 'secondary.main' }}>Hesan Naveed</Link>
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer; 